import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enTranslations from './locales/en.json'
import nlTranslations from './locales/nl.json'
import { getDefaultLanguageFromDomain } from '../utils/domain'

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enTranslations,
            },
            nl: {
                translation: nlTranslations,
            },
        },
        fallbackLng: getDefaultLanguageFromDomain(),
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
        },
    })

export default i18n 